// extracted by mini-css-extract-plugin
module.exports = {"navigationList":"navigation-list-module__navigationList___yvTGP"};